import styles from '../../search.module.scss'
import { formatWithCommas } from '@/lib/utilities/search'
import { isProd } from '@/lib/utilities/system'

type MinMaxNumberProps = {
  activeMin: number
  activeMax: number
  availableMinimum: number
  availableMaximum: number
  minInput: number
  maxInput: number
  minGap: number
  handleMaxInput: (value: number) => void
  handleMinInput: (value: number) => void
  label?: string
}

export const MinMaxNumber = ({
  activeMin,
  activeMax,
  availableMaximum,
  availableMinimum,
  minInput,
  maxInput,
  minGap = 50,
  handleMinInput,
  handleMaxInput,
  label,
}: MinMaxNumberProps) => {
  return (
    <div className={styles.minmax}>
      <div title="Minimum">
        <span className={styles.label}>Min</span>
        <div className={styles['input-wrapper']}>
          <span className={styles.adornment}>£</span>
          <input
            className={`${styles.input}${!isProd() && label ? ` search__${label.toLowerCase()}-input-min` : ''}`}
            min={availableMinimum}
            max={activeMax - minGap}
            value={formatWithCommas(minInput).toString().split('.')[0]}
            type="text"
            title="Minimum"
            onChange={e => handleMinInput(parseInt(e.target.value, 10))}
            inputMode="numeric"
          />
        </div>
      </div>
      <div title="Maximum">
        <span className={styles.label}>Max</span>
        <div className={styles['input-wrapper']}>
          <span className={styles.adornment}>£</span>
          <input
            className={`${styles.input}${!isProd() && label ? ` search__${label.toLowerCase()}-input-max` : ''}`}
            min={activeMin + minGap}
            max={availableMaximum}
            value={formatWithCommas(maxInput).toString().split('.')[0]}
            type="text"
            title="Maximum"
            onChange={e => handleMaxInput(parseInt(e.target.value, 10))}
            inputMode="numeric"
          />
        </div>
      </div>
    </div>
  )
}
